module.exports = __webpack_public_path__ + "img/119.62937122.gif";